import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ToastService } from 'src/app/services/toast.service';
import { VehiclesService } from 'src/app/services/vehicles.service';

@Component({
  selector: 'app-edit-vehicle',
  templateUrl: './edit-vehicle.page.html',
  styleUrls: ['./edit-vehicle.page.scss'],
})
export class EditVehiclePage implements OnInit {
  nextYear = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).getFullYear()
  @Input() vehicles: object;
  @Input() vehicle: object;
  editVehicleForm: FormGroup;
  constructor(
    private errorHandlerSRV:ErrorHandlerService,
    private toastSRV:ToastService,
    private loaderSRV:LoaderService,
    public modalController: ModalController,
    private fb: FormBuilder,
    public dataService: DataService,
    public translateService: TranslateService,
    public vehiclesSRV:VehiclesService
  ) {}

  ngOnInit() {
   
    /* Get ID's based on Name start */
    const ProvID = this.vehiclesSRV?.provinces.find(
      (v) => v.ProvName === this.vehicle?.['ProvName']
    )?.ProvID;
    const PlateTypeID = this.vehiclesSRV?.plateTypes.find(
      (v) => v.TypeName === this.vehicle?.['plateTypeName']
    )?.TypeID;
    const MakeID = this.vehiclesSRV?.makes.find(
      (v) => v.MakeName === this.vehicle?.['MakeName']
    )?.MakeID;
    const TypeID = this.vehiclesSRV?.types.find(
      (v) => v.TypeName === this.vehicle?.['TypeName']
    )?.TypeID;
    const ColourID = this.vehiclesSRV?.colours.find(
      (v) => v.ColourName === this.vehicle?.['ColourName']
    )?.ColourID;
    const isElectricVehicle = this.vehicle?.['electric_vehicle']
    /* Get ID's based on Name end */
    this.editVehicleForm = this.fb.group({
      ProvID: [ProvID, [Validators.required]],
      PlateTypeID: [PlateTypeID, [Validators.required]],
      MakeID: [MakeID, ],
      TypeID: [TypeID, ],
      ColourID: [ColourID, ],
      Year: [this.vehicle?.['Year'], [Validators.min(1900),Validators.max(this.nextYear),Validators.maxLength(4),Validators.minLength(4)]],
      electric_vehicle:[isElectricVehicle]
    });
    
  }

  onCloseModal() {
    this.modalController.dismiss();
  }
  onSaveChanges() {
    this.loaderSRV.showLoader(this.translateService.instant('keys.data.common.loading') || 'Loading...')
    const url = `api/v1/user/vehicles/edit/${this.vehicle?.['VehicleID']}`;
    const data = this.editVehicleForm.value;
    this.dataService.postData(url, data).subscribe({
      next:(res:any)=>{
        if(res['status']=='success'){
          this.loaderSRV.dismissLoader()
          this.modalController.dismiss({
            reload: true,
          });
          this.toastSRV.presentToast(res?.message)
        } else {
          this.loaderSRV.dismissLoader()
          this.errorHandlerSRV.displayErrorMessage(res,true)
        }
      },error:err=>{
        this.errorHandlerSRV.displayErrorMessage(err,true)
      }
      
     
    });
  }
}
